import { useMemo } from 'react';

import { buildBasePath } from '@atlassian/post-office-context/build-base-path';
import { usePostOfficeEnvironment } from '@atlassian/post-office-context/post-office-environment';

export const useBuildBasePath = (): {
	path: string;
	baseUrl?: string;
} => {
	const postOfficeEnvironment = usePostOfficeEnvironment();

	return useMemo(
		() => buildBasePath(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs),
		[postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs],
	);
};
